export enum ContractorProjectDocActions {
  SendToCompletionConfirmation = 100,
  CancelCompletionConfirmation = 101,
  EditSigner = 102,
  GeneratePaperSigning = 103,
  StartPaperSigningApproval = 104,
  PaperSigningGenerated = 105
}